import React from 'react'

import ArtistContractSelf from '../files/artist-contract-self-managed-2018.pdf'
import ArtistContractFlexi from '../files/artist-flexi-contract-2018.pdf'
import ArtistContractFull from '../files/artist-full-package.pdf'

import Layout from '../components/layout'
import InfoPack from '../files/planning-an-exhibition.pdf'

const ArtistsPage = () => (
  <Layout>
    <article className="cf ph3 ph5-ns pv5">
      <div className="fn fl-ns w-40-ns pr4-ns">
        <h1 className="f2 lh-title fw9 mb3 mt0 pt3 bt bw2">
          Artists' Resources
        </h1>
        <h2 className="f3 mid-gray lh-title">
          All <span className="turquoise">information</span> artists need working with us.
        </h2>
        <img className=""/>
      </div>
      <div className="fn fl-ns w-60-ns">
        <article className="pv4 ph3 ph0-l">
          <div className="flex flex-column flex-row-ns">
            <div className="w-100 w-100-ns pr3-ns order-2 order-1-ns">
              <p className="measure">
                All the responsibility is with the Artist. We require an artist CV and a proposal for the exhibition from the Artist. The Artist is responsible for the hanging of all artwork, opening and closing the gallery and being in attendance while the exhibition is open.
              </p>
              <p className="measure">
                Riverton Community Arts Centre (RCAC) will actively endeavour to sell artwork on behalf of Artists exhibiting through free advertising, social media, website, email marketing and event listings and newsletters. The Artist can work alongside RCAC to run the exhibition, manage sales and visitors.
              </p>
              <p className="measure">
                Riverton Community Arts Centre (RCAC) will actively endeavour to sell artwork on behalf of Artists exhibiting through advertising, social media, website, email marketing and event listings and newsletter. RCAC would be responsible for the hanging of all artwork, staffing, opening and closing the gallery while the exhibition is open.
              </p>
              <p className="measure"> For more information view or download <strong><a className="turquoise" target="_blank" href={InfoPack}>Planning an Exhibition</a></strong></p>
            </div>
          </div>
        </article>
      </div>
    </article>
  </Layout>
)

export default ArtistsPage
